import { render, staticRenderFns } from "./LevelOneTab.vue?vue&type=template&id=2911de1e"
import script from "./LevelOneTab.vue?vue&type=script&lang=js"
export * from "./LevelOneTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports